import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import {useSelector} from "react-redux";
import Typography from '@mui/material/Typography';


const ErrorPage = () => {
    const message = useSelector(state => state.errorResponse.message);

    return (
        <div>
            <div style={{height: '30px'}}></div>
            <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                <Card style={{width: "300px", alignSelf: "center"}}
                      raised={true}
                      width="150px"
                >
                    <CardContent>
                        <Typography variant={"h4"}
                                    style={{textAlign: "center", whiteSpace: "pre-line"}}>{message}</Typography>
                    </CardContent>
                </Card>
            </div>
            <div style={{height: '30px'}}></div>
        </div>
    );
};

export default ErrorPage;
